import { NO_IMAGE } from 'chemistry'

const CORRECT_SIZE = '80'
const IMAGE_SCALER_FORMAT = /\/\d{4,}-\d{2,}-\d{2,}\.\w+/
const PIM_IMAGE_FORMAT = /s\d{2,}\/origin/

function isShippingOnly(deliveryCode) {
  const shippingRegExp = /^SHD|^\d+$/
  return shippingRegExp.test(deliveryCode)
}

function isOnlineOnly(deliveryModes = []) {
  try {
    return deliveryModes.every(mode => isShippingOnly(mode.code))
  } catch (e) {
    return false
  }
}

const validImage = imgUrl => IMAGE_SCALER_FORMAT.test(imgUrl) || PIM_IMAGE_FORMAT.test(imgUrl.toLowerCase())

const setImageUrlToFitImageSize = imgUrl => {
  const [idImgAnPath, , widthAndFileExtension] = imgUrl.split('-')
  const [, fileExtension] = widthAndFileExtension.split('.')

  return `${idImgAnPath}-${CORRECT_SIZE}-${CORRECT_SIZE}.${fileExtension}`
}

const setImageUrlToFitImageSizePimDam = imgUrl => {
  const urlParts = imgUrl.split('/')
  urlParts.splice(urlParts.length - 1, 0, `${CORRECT_SIZE}x${CORRECT_SIZE}`)
  return urlParts.join('/').replace(/\.(\w)+$/, '.webp')
}

const processImageUrl = imgUrl => {
  if (IMAGE_SCALER_FORMAT.test(imgUrl)) {
    return setImageUrlToFitImageSize(imgUrl)
  } else {
    return setImageUrlToFitImageSizePimDam(imgUrl)
  }
}

const adaptImages = images => {
  let imagesList = (images || []).filter(image => validImage(image.url))

  if (!imagesList || !imagesList.length) {
    return [{ src: NO_IMAGE, title: '' }]
  }

  imagesList = imagesList.map(image => {
    return {
      src: processImageUrl(image.url),
      imageType: image.imageType,
      title: image.altText
    }
  })

  const properImageList = imagesList.filter(img => img.imageType !== 'PRIMARY') || []
  const primaryImage = imagesList.filter(img => img.imageType === 'PRIMARY')[0]
  if (primaryImage) properImageList.unshift(primaryImage)

  return properImageList
}

export default function product(structure, isGuest, index) {
  const image = adaptImages(structure.images)[0]
  return {
    id: structure.variantCode || index,
    title: structure.name,
    link: structure.link,
    category: {
      id: 0,
      title: structure.categoryName,
      slug: structure.categoryName
    },
    poster: {
      thumbUrl: image.src,
      alt: structure.name,
      title: structure.name
    },
    brands: structure.brands,
    onlineOnly: isOnlineOnly(structure.deliveryModes)
  }
}
